'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var useEditCard = require('./useEditCard.js');
var React = require('react');
var Button = require('../../../components/Button/Button.js');
require('@babel/runtime/helpers/defineProperty');
require('../../../components/Button/StatisticsButton.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * `Edit card cancel button
 *
 * Cancels the editing state. Used in the `EditCardFooter`.
 */
var EditCardCancelButton = react.forwardRef(function (props, ref) {
  var _useEditCardContext = useEditCard.useEditCardContext(),
    getCancelButtonProps = _useEditCardContext.getCancelButtonProps;
  return /*#__PURE__*/React__default["default"].createElement(Button.Button, _extends__default["default"]({
    variant: "ghost",
    colorScheme: "red"
  }, getCancelButtonProps(props, ref)));
});
EditCardCancelButton.displayName = 'EditCardCancelButton';
exports.EditCardCancelButton = EditCardCancelButton;